// 意见反馈
import $http from '../../utils/http';
import $httpPost from '../modules/complaintApis/http'

const currentUser = params => {
    // 获取首页用户信息
    return $http({
        url: '/feedback-backend/ordinary/login/getLoginInfo',
        params
    });
};
const getUploadUrl = params => {
    // 获取私有读文件临时上传链接接口
    return $http({
        url: '/feedback-backend/ordinary/tencent/cos/getUploadUrl/'+params.fileName,
        params: {
            contentType: params.contentType,
            type: params.type
        },
        method: 'GET',
    });
};
const save = data => {
    // 意见反馈填报接口
    return $httpPost({
        url: '/feedback-backend/ordinary/feedbackUser/save',
        headers: { 'showLoading': false },
        data,
        method: 'POST'
    });
};
const pageList = params => {
    // 意见反馈列表查询接口
    return $http({
        url: '/feedback-backend/ordinary/feedbackUser/pageList',
        params,
        method: 'GET'
    });
};
const AdminPageList = data => {
    return $httpPost({
        url: '/feedback-backend/admin/feedbackSystem/pageList',
        headers: { 'showLoading': false },
        data,
        method: 'POST'
    })
  }
const adminDetail = params => {
    // admin意见反馈列表查询接口
    return $http({
        url: '/feedback-backend/admin/feedbackSystem/detail',
        params,
        method: 'get',
    });
};

const detail = params => {
    // 意见反馈详情查询接口
    return $http({
        url: '/feedback-backend/ordinary/feedbackUser/detail',
        params,
        method: 'GET',
    });
};


const systemList = params => {
    return $http({
        url: '/feedback-backend/ordinary/feedbackUser/systemList',
        params,
        method: 'GET',
    });
};

const getImage = params => {
    return $http({
        url: params,
        method: 'GET',
    });
}

export default {
    currentUser,
    getUploadUrl,
    pageList,
    AdminPageList,
    save,
    systemList,
    detail,
    adminDetail,
    getImage
}